import {Component, ChangeDetectionStrategy} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {AuthService} from "@app/_services/auth.service";
import {LoginResponse} from "@app/_models/api";
import {ToastService} from "@app/_services/toast.service";

@Component({
    selector: 'app-login',
    imports: [
        ReactiveFormsModule,
        RouterLink,
        NgOptimizedImage
    ],
    templateUrl: './login.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './login.component.scss'
})
export class LoginComponent {
    loginForm = new FormGroup({
        email: new FormControl("", [Validators.required, Validators.email]),
        password: new FormControl("", Validators.required),
    });
    loading = false;

    constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService, private toastService: ToastService) {
    }

    onSubmit() {
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        const controls = this.loginForm.controls;

        this.authService.login(controls.email.value!, controls.password.value!)
            .subscribe({
                next: (response: LoginResponse) => {
                    if (response.challenge != undefined) {
                        this.router.navigate(['account', 'new-password-required'], {
                            queryParams: {
                                email: controls.email.value,
                                session: response.challenge!.session
                            }
                        }).then();
                        return;
                    }

                    this.loading = false;
                    this.authService.handleSuccessfulLogin(response);
                    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
                    this.router.navigateByUrl(returnUrl).then();
                },
                error: () => {
                    this.loading = false;
                    this.toastService.showDanger("Login Error", "Invalid user, please login with valid credentials.");
                }
            });
    }
}
